<template>
  <default-text-input
    ref="input"
    :value="value"
    :label="label"
    :tabindex="tabindex"
    :maxlength="maxlength"
    :placeholder=placeholder
    :debounce="50"
    type="tel"
    :autofocus="autofocus"
    class="birth-date-input"
    :input-style="{ 'text-align': 'right' }"
    @focus="onFocus"
    @blur="onBlur"
    v-on="$listeners"
  >

  </default-text-input>
</template>

<script>
import _ from 'lodash';
import DefaultTextInput from '@/components/styled/DefaultTextInput';

export default {
  name: 'BirthDateInput',
  components: { DefaultTextInput },
  data() {
    return {
      focused: false,
    };
  },
  props: {
    value: String,
    label: {
      type: String,
      required: true,
    },
    maxlength: {
      type: Number,
      required: true,
    },
    autofocus: Boolean,
    tabindex: Number,
  },
  computed: {
    placeholder() {
      if (_.isEmpty(this.value) && !this.focused) {
        return '0'.repeat(this.maxlength);
      }
      return null;
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      this.focused = false;
    },
  },
};
</script>

<style scoped lang="scss">

.birth-date-input {
  font-size: 20px;
}

</style>
